import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["submenu"];

  connect() {
    this.handleOutsideClick = this.handleOutsideClick.bind(this);
  }

  toggle(event) {
    event.stopPropagation();
    const isHidden = this.submenuTarget.classList.contains("hidden");

    if (isHidden) {
      this.submenuTarget.classList.remove("hidden");
      document.addEventListener("click", this.handleOutsideClick);
    } else {
      this.submenuTarget.classList.add("hidden");
      document.removeEventListener("click", this.handleOutsideClick);
    }
  }

  handleOutsideClick(event) {
    if (!this.element.contains(event.target)) {
      this.submenuTarget.classList.add("hidden");
      document.removeEventListener("click", this.handleOutsideClick);
    }
  }

  disconnect() {
    document.removeEventListener("click", this.handleOutsideClick);
  }
}
